import Translator from 'bazinga-translator'

import { FAVORITE_GAME_CATEGORY_SLUG, LANG } from '../../../../../containers/App/constants'
import { ICON_FAVORITE } from '../../../../IconLink/constants'

export function generateFavoriteCategoryObject() {
  return {
    icon: ICON_FAVORITE,
    id: 'cat_favorites',
    isActive: false,
    label: Translator.trans('game_category_favorites_label'),
    slug: FAVORITE_GAME_CATEGORY_SLUG,
    uri: `/${LANG}/games/favorites`,
  }
}
